import { useQuery } from '@tanstack/react-query';
import { getCoupons, getClippedCoupons, isAuthenticated } from '../api/coupons';
import type { Coupon, GetCouponsParams } from '../types/coupons';

export function useCoupons(params: GetCouponsParams = {}) {
  const storeId = params.storeId ?? '';
  const authenticated = isAuthenticated();

  return useQuery<Coupon[]>({
    queryKey: ['coupons', storeId, authenticated],
    queryFn: async () => {
      if (!authenticated) {
        const response = await getCoupons(storeId);
        return response.items;
      }

      // Fetch full catalog + clipped in parallel, then merge clip state.
      const [catalogRes, clippedRes] = await Promise.all([
        getCoupons(storeId),
        getClippedCoupons(),
      ]);

      const clippedIds = new Set(clippedRes.items.map((c) => c.id));

      return catalogRes.items.map((c) => ({
        ...c,
        isClipped: clippedIds.has(c.id),
      }));
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
